import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { Country } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { DealDocumentsService } from 'src/pages/admin/trading/deals/deal-documents/deal-documents.service'
import { replayForm } from 'src/shared/utils/replay-form'

export interface DocsCountryConfirmationDialogData {
  defaultDocsCountryCode: string
  countries: DeepReadonly<Country[]>
  message?: string
  buyerId?: string
}

export interface DocsCountryConfirmationDialogResult {
  docsCountryCode: string
}

@Component({
  selector: 'tc-docs-country-confirmation-dialog',
  templateUrl: './docs-country-confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DocsCountryConfirmationDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<DocsCountryConfirmationDialogComponent, DocsCountryConfirmationDialogResult>>(MatDialogRef)
  private fb = inject(UntypedFormBuilder)
  private DealDocuments = inject(DealDocumentsService)
  data = inject<DocsCountryConfirmationDialogData>(MAT_DIALOG_DATA)


  form = this.fb.group({
    docsCountryCode: ['', Validators.required]
  })

  docsCountryIssues$: Observable<string>

  ngOnInit(): void {
    this.form.patchValue({
      docsCountryCode: this.data.defaultDocsCountryCode
    })

    this.docsCountryIssues$ = this.data.buyerId
      ? this.DealDocuments.docsCountryIssues$(replayForm(this.form).pipe(map(f => ({
        buyer_id: this.data.buyerId,
        country_code: f.docsCountryCode,
      }))))
      : of('')
  }

  onConfirm(): void {
    if (this.form.valid) {
      this.dialogRef.close({ docsCountryCode: this.form.value.docsCountryCode })
    }
  }

  onCancel(): void {
    this.dialogRef.close()
  }
}